module.exports = __webpack_public_path__ + "img/enhancer2.81955573.webp";